import useIsMobile from "../../hooks/useIsMobile";

import GuideDesktopLayout from "./GuideDesktopLayout";
import GuideMobileLayout from "./GuideMobileLayout";

export default function GuideLayout() {

    const isMobile =
        useIsMobile();

    if (isMobile) {

        return <GuideMobileLayout />;

    }

    return <GuideDesktopLayout />;

}